<template>
  <div class="flex justify-center lg:justify-end mt-4">
    <button
        class="flex justify-center items-center gap-2 font-bold text-xl"
        @click.prevent="addAnother"
    >
      Add another experience
      <span class="bg-primary text-dark h-12 w-12 rounded-full flex items-center justify-center">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M8 1.5V6H12.5C13.0312 6 13.5 6.46875 13.5 7C13.5 7.5625 13.0312 8 12.5 8H8V12.5C8 13.0625 7.53125 13.5 7 13.5C6.4375 13.5 6 13.0625 6 12.5V8H1.5C0.9375 8 0.5 7.5625 0.5 7C0.5 6.46875 0.9375 6 1.5 6H6V1.5C6 0.96875 6.4375 0.5 7 0.5C7.53125 0.5 8 0.96875 8 1.5Z"
              fill="currentColor"/>
        </svg>
      </span>
    </button>
  </div>
</template>
<script>
export default {
  name: 'AddAnother',
  methods: {
    addAnother() {
      this.$emit('add-another')
    }
  }
}
</script>